import { isEmpty, isNil, either } from "ramda";

export const isEmptyObjValues = (obj) => {
	if (typeof obj !== "object" || isNil(obj)) return false;
	return Object.values(obj).some(either(isEmpty, isNil));
};
